var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProperty = function SvgProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.27 3.121a.602.602 0 0 1 .723 0l1.288.97.997.752 5.748 4.335c.16.142.239.301.239.48v10.219c.031.385-.104.578-.406.578H3.6a.6.6 0 0 1-.6-.6V9.657c0-.188.088-.366.239-.479zm.362 1.23L4.2 9.956v9.3h5.25v-4.952a.6.6 0 0 1 .6-.6h3.165a.6.6 0 0 1 .6.6v4.951h5.25V9.956l-7.433-5.605zm.983 10.553H10.65v4.351h1.965v-4.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
export default SvgProperty;